<template>
    <div class="callParticipant">
       <VehicleBrief :label="vehicle.vehicleLabel" sizeClass="h6" :showLink="false" :removeGroupCall="true" />
        <span class="endpointStatus" :class="status">{{ $t('voip.group_call.status.'+ status) }}</span>
    </div>
</template>

<script>
import phone from '@/store/dispatching/phone';
import realtime from '@/store/realtime/realtime'
import VehicleBrief from '@/components/Realtime/VehicleBrief'

export default {
    name: 'GroupCallParticipant',
    components: { VehicleBrief },
    props: {
        sipClientId : {
            type: String
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
        if (!this.$store.state.realtime) {
            this.$store.registerModule('realtime', realtime);
        }
        this.$store.dispatch('realtime/getVehicles')
    },
    mount: function() {
        this.updateStatus(this.endpointStatus, this.callStatus )
    },
    computed: {
        endpointStatus() {
            return this.$store.state.phone.phonebook[this.sipClientId]?.status
        },
        callStatus() {
            return this.$store.state.phone.phonebook[this.sipClientId]?.callStatus
        },
        status() {
           if (this.endpointStatus == 'online') {
                if (this.callStatus == 'up') {
                    return 'connected';
                }
                if (this.callStatus == 'ringing')
                    return 'connecting';
                return 'online';
            }
            return 'offline';
        }, 
        vehicle() {
            return this.$store.getters["realtime/getVehicleBySipId"]( this.sipClientId )
        }
    },
}
</script>

<style scoped lang="scss">
.endpointStatus.online {
    color:darkgreen;
}
.endpointStatus.offline {
    color: red;
}
.endpointStatus.connected {
    color: lightgreen
}
.endpointStatus.connecting {
    color: yellowgreen
}
.callParticipant {
    margin-top: 0.2em;
}
</style>